class LastUserTestCasesReportController {
    constructor($window, $browser, $uibModal, $location, moment, ngProgressFactory, UserDetailsApi, toastr, SettingsService, ReportUtils, ReportUtilityServiceApi, ReportServiceApi, StateService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state = {
                linkFromName: true,
                userDetails: null,
                selectedTester: { Id: -1, Name: '' },
                selectedSim: { Id: -1, Name: '' },
                selectedSuite: { Id: -1, Name: '' },
                DateFormats: {
                    DateTimeFormat: '',
                    DateFormat: '',
                    TimeFormat: ''
                },
                showFilters: true,
                hideNav: _.startsWith(this.location.path(), '/Reports')
            };
            this.data = {
                testers: [],
                sims: [],
                suites: [],
                originalRows: [],
                rows: []
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.lastUserTestCasesReport = {
                Id: 0,
                Name: '',
                Description: 'Last User TestCases Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.rowCount = 0;
            this.hide = true;
            this.columnDefs = [
                {
                    headerName: 'Id',
                    field: 'Id',
                    width: 50,
                    minWidth: 50,
                    hide: this.hide
                },
                {
                    headerName: 'UserID',
                    field: 'UserId',
                    width: 110,
                    minWidth: 112,
                    hide: this.hide
                },
                {
                    headerName: 'simID',
                    field: 'SimulatorId',
                    width: 110,
                    minWidth: 112,
                    hide: this.hide
                },
                {
                    headerName: 'suiteID',
                    field: 'TestSuiteId',
                    width: 110,
                    minWidth: 112,
                    hide: this.hide
                },
                {
                    headerName: 'caseID',
                    field: 'TestCaseId',
                    width: 110,
                    minWidth: 112,
                    hide: this.hide
                },
                {
                    headerName: 'UserName',
                    field: 'UserName',
                    width: 110,
                    minWidth: 112,
                    hide: this.hide
                },
                {
                    headerName: 'User',
                    field: 'Description',
                    width: 150,
                    minWidth: 112
                },
                // { headerName: "Simulator Name", field: "SimName", width: 250, minWidth: 175, cellRenderer: simCellRenderer },
                {
                    headerName: 'Simulator',
                    field: 'SimName',
                    width: 250,
                    minWidth: 175
                },
                // { headerName: "Test Suite Name", field: "TestSuiteName", width: 250, minWidth: 175, cellRenderer: suiteCellRenderer },
                {
                    headerName: 'Test Suite',
                    field: 'TestSuiteName',
                    width: 250,
                    minWidth: 175
                },
                {
                    headerName: 'Test Case',
                    field: 'TestCaseName',
                    width: 250,
                    minWidth: 175,
                    cellRenderer: this.caseCellRenderer
                }
                // { headerName: "Test Case Name", field: "TestCaseName", width: 250, minWidth: 175 }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
            });
            this.UserDetailsApi.get().then((response) => {
                this.state.userDetails = response.data; // setup our user details
                // Support sees all tester reports
                if (this.state.userDetails.IsAdmin ||
                    this.state.userDetails.IsSupport) {
                    if (this.state.userDetails.IsAdmin) {
                        this.state.linkFromName = false;
                    }
                    this.ReportServiceApi.getAllSelectedUserTestCases().then((response) => {
                        this.traceProgress.complete();
                        this.data.rows = response.data;
                        this.data.originalRows = response.data;
                        this.getDropdownData();
                        this.state.selectedTester = this.data.testers[0];
                        this.state.selectedSim = this.data.sims[0];
                        this.state.selectedSuite = this.data.suites[0];
                        this.state.showFilters = true;
                        // Get the data
                        this.gridOptions.api.setRowData(this.data.rows);
                        this.defaultSort();
                        return;
                    });
                }
                if (this.state.userDetails.IsProjectTester) {
                    this.ReportServiceApi.getTeamSelectedUserTestCases(this.state.userDetails.Team.Id).then((response) => {
                        this.traceProgress.complete();
                        this.data.rows = response.data;
                        this.data.originalRows = response.data;
                        this.getDropdownData();
                        this.state.selectedTester = this.data.testers[0];
                        this.state.selectedSim = this.data.sims[0];
                        this.state.selectedSuite = this.data.suites[0];
                        this.state.showFilters = true;
                        // Get the data
                        this.gridOptions.api.setRowData(this.data.rows);
                        this.defaultSort();
                        return;
                    });
                }
                this.traceProgress.complete();
            }, () => {
                this.traceProgress.complete();
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.ReportServiceApi.getReportByName('LastUserTestCasesReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.lastUserTestCasesReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.defaultSort = () => {
            this.gridOptions.columnApi.applyColumnState({
                state: [{ colId: 'Description', sort: 'asc' }]
            });
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.exportCsv = () => {
            let reportName = this.ReportService.addDateToTitle(this.lastUserTestCasesReport.Description + '.csv');
            let params = {
                fileName: reportName
                // customHeader: "Selected User Tests Report generated on 31 Jan 2016\n"
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.caseCellRenderer = (row) => {
            let tooltip = 'View Trace Details for ' + row.data.TestCaseName;
            let action = 'vm.caseTraceDetails(data)';
            return this.createLink(row.data.TruncatedTestCaseName, tooltip, action);
        };
        this.buildTraceSummaryPath = (testerId, simId, suiteId) => {
            return suiteId
                ? [
                    'TraceSummarySource/SelectedUserTestCasesReport/',
                    testerId,
                    '/',
                    simId,
                    '/',
                    suiteId
                ].join('')
                : [
                    'TraceSummarySource/SelectedUserTestCasesReport/',
                    testerId,
                    '/',
                    simId
                ].join('');
        };
        this.simTraceSummary = (row) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = row.UserId || loggedInUserId;
            let url = this.buildTraceSummaryPath(testerId.toString(), row.SimId, null);
            this.StateService.reset();
            this.StateService.selectedTester = {
                Id: row.UserId,
                Name: row.Description
            };
            this.StateService.selectedSim = {
                Id: row.SimulatorId,
                Name: row.SimName
            };
            this.location.path(url);
        };
        this.suiteTraceSummary = (row) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = row.UserId || loggedInUserId;
            let url = this.buildTraceSummaryPath(testerId.toString(), row.SimulatorId, row.TestSuiteId);
            this.StateService.reset();
            this.StateService.selectedTester = {
                Id: row.UserId,
                Name: row.Description
            };
            this.StateService.selectedSim = {
                Id: row.SimulatorId,
                Name: row.SimName
            };
            this.StateService.selectedSuite = {
                Id: row.TestSuiteId,
                Name: row.TestSuiteName
            };
            this.location.path(url);
        };
        this.caseTraceDetails = (row) => {
            let mode = { view: false, run: false };
            // console.log(row);
            let selectedItems = {
                selectedTester: { Id: row.UserId, Name: row.Description },
                selectedSim: { Id: row.SimulatorId, Name: row.SimName },
                selectedSuite: { Id: row.TestSuiteId, Name: row.TestSuiteName },
                selectedTest: { Id: row.TestCaseId, Name: row.TestCaseName },
                unknownUser: { Id: 0, Name: 'Unknown' },
                fromTester: false
            };
            this.openDetails(selectedItems, mode);
        };
        this.openDetails = (selectedItems, mode) => {
            let tdParams = {
                selectedItems: selectedItems,
                mode: mode,
                user: this.state.userDetails,
                overTheShoulder: false
            };
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                keyboard: false,
                component: 'traceDetailsModal',
                resolve: {
                    params: () => {
                        return tdParams;
                    }
                }
            });
        };
        this.autoSizeAll = () => {
            let allColumnIds = [];
            if (this.columnDefs === undefined || this.columnDefs === null) {
                this.columnDefs = this.gridOptions.columnDefs;
            }
            this.columnDefs.forEach((columnDef) => {
                allColumnIds.push(columnDef.field);
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
            this.autoSizeAll();
        };
        this.createLink = (data, tooltip, action) => {
            let link = [
                '<span',
                'ng-if="!vm.state.linkFromName">',
                data,
                '</span><a ng-href=""',
                'class="pointer"',
                'title="',
                tooltip,
                '"',
                'ng-if="vm.state.linkFromName"',
                'ng-click="',
                action,
                '">',
                data,
                '</a>'
            ].join(' ');
            return link;
        };
        this.selectTester = (tester) => {
            if (this.data.testers[0] === undefined ||
                this.data.testers[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedTester = this.data.testers[0];
            if (tester) {
                this.state.selectedTester = tester;
            }
            else {
                this.state.selectedSim = this.data.sims[0];
                this.state.selectedSuite = this.data.suites[0];
            }
            this.data.rows = this.filteredReports();
            this.gridOptions.api.setRowData(this.data.rows);
        };
        this.selectSim = (sim) => {
            if (this.data.sims[0] === undefined || this.data.sims[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedSim = this.data.sims[0];
            if (sim) {
                this.state.selectedSim = sim;
            }
            else {
                this.state.selectedSuite = this.data.suites[0];
            }
            this.data.rows = this.filteredReports();
            this.gridOptions.api.setRowData(this.data.rows);
        };
        this.selectSuite = (suite) => {
            if (this.data.sims[0] === undefined || this.data.sims[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedSuite = this.data.suites[0];
            if (suite) {
                this.state.selectedSuite = suite;
            }
            this.data.rows = this.filteredReports();
            this.gridOptions.api.setRowData(this.data.rows);
        };
        this.filteredReports = () => {
            let reports = this.data.originalRows;
            let testerId = this.state.selectedTester.Id || 0;
            let simId = this.state.selectedSim.Id || 0;
            let suiteId = this.state.selectedSuite.Id || 0;
            // console.log(testerId, simId, suiteId);
            let testerFiltered = _.filter(reports, (item) => {
                if (testerId > 0) {
                    return item.UserId === testerId;
                }
                return reports;
            });
            let simFiltered = _.filter(testerFiltered, (item) => {
                if (simId > 0) {
                    return item.SimulatorId === simId;
                }
                return testerFiltered;
            });
            let suiteFiltered = _.filter(simFiltered, (item) => {
                if (suiteId > 0) {
                    return item.TestSuiteId === suiteId;
                }
                return simFiltered;
            });
            return _.sortBy(suiteFiltered, ['Description']);
        };
        this.testers = (reports) => {
            let mapped = _.map(reports, (item) => {
                // console.log(item);
                return {
                    Id: item.UserId,
                    Name: item.Description
                };
            });
            // console.log(testers);
            return this.getUnique(mapped, 'Testers');
        };
        this.sims = (reports) => {
            let mapped = _.map(reports, (item) => {
                // console.log(item);
                return {
                    Id: item.SimulatorId,
                    Name: item.SimName
                };
            });
            return this.getUnique(mapped, 'Simulators');
        };
        this.suites = (reports) => {
            let mapped = _.map(reports, (item) => {
                // console.log(item);
                return {
                    Id: item.TestSuiteId,
                    Name: item.TestSuiteName
                };
            });
            // console.log(testers);
            return this.getUnique(mapped, 'Suites');
        };
        this.getUnique = (reports, itemType) => {
            // @ts-ignore lodesh
            let unique = _.uniqBy(reports, (item) => {
                return item.Id;
            });
            if (unique.length === 0) {
                return [{ Id: 0, Name: 'No ' + itemType + ' available' }];
            }
            let sorted = _.sortBy(unique, ['Name']);
            let all = { Id: 0, Name: 'All ' + itemType };
            // console.log(sorted);
            // @ts-ignore lodesh
            return _.concat(all, sorted);
        };
        this.getDropdownData = () => {
            this.data.testers = this.testers(this.data.rows);
            this.data.sims = this.sims(this.data.rows);
            this.data.suites = this.suites(this.data.rows);
        };
        this.window = $window;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.location = $location;
        this.moment = moment;
        this.ngProgressFactory = ngProgressFactory;
        this.UserDetailsApi = UserDetailsApi;
        this.toastr = toastr;
        this.SettingsService = SettingsService;
        this.ReportUtils = ReportUtils;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportServiceApi = ReportServiceApi;
        this.StateService = StateService;
    }
}
angular.module('app').component('lastUserTestCasesReport', {
    templateUrl: 'Scripts/App/partials/Reports/last-user-test-cases-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: LastUserTestCasesReportController
});
